module.exports = __webpack_public_path__ + "img/identityR.763d8f5d.png";